<template>
  <div class="currency">
    <el-dialog
      :visible.sync="showCurrency"
      width="400px"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      center
    >
      <div class="title" slot="title">
        <span>{{ currencyParams.title }}</span>
        <div class="close" @click="closeFn">
          <i class="icon"></i>
        </div>
      </div>
      <div class="itemBox" v-show="currencyParams.type === 'printing'">
        <p>添加一个要打印的文件</p>
        <ul class="itemList">
          <el-upload
            v-if="printable < 10"
            class="upload"
            :action="uploadUrl"
            :headers="header"
            :on-progress="uploadProgress"
            :on-success="success"
            :on-error="err"
            :before-upload="beforeAvatarUpload"
            :with-credentials="true"
            :data="uploadParameter"
            :show-file-list="false"
            :on-change="filesChange"
            multiple
            :accept="allFileType"
            ref="uploader"
          >
            <li slot="trigger">
              <img src="@/assets/img/printing/item1.png" alt="选择本地文件" />
              <span>选择本地文件</span>
            </li>
          </el-upload>
          <li v-else @click="forbidLocalUpload">
            <img src="@/assets/img/printing/item1.png" alt="选择云文档" />
            <span>选择本地文件</span>
          </li>
          <li @click="cloudDocument">
            <img src="@/assets/img/printing/item2.png" alt="选择云文档" />
            <span>选择云文档</span>
          </li>
          <li @click="mobilePrintingFn">
            <img
              src="@/assets/img/printing/item3.png"
              alt="手机打印"
              style="margin-right: 18px; margin-left: 4px"
            />
            <span>手机打印</span>
          </li>
        </ul>
      </div>
      <div class="codeBox" v-if="currencyParams.type === 'mobile'">
        <div class="codeIcon">
          <img src="@/assets/img/deviceManagement/code.png" alt="" />
        </div>
        <p>微信扫一扫，快速打印</p>
      </div>
    </el-dialog>
  </div>
</template>

<script type="text/javascript">
import axios from "axios";
import uploadMixin from "mixins/upload.js";
import { REQUEST_URL, APP_KEY } from "const";
import { signIn } from "../../../../utils/utils";
import { fileQuery, getAllParameters } from "api/api";
import { mapState } from "vuex";
export default {
  name: "currency",
  components: {},
  computed: {
    ...mapState("user", ["accessToken"])
  },
  props: {
    showCurrency: {
      type: Boolean
    },
    currencyParams: {
      type: Object,
      default: function() {
        return {};
      }
    }
  },
  mixins: [uploadMixin],
  data() {
    return {
      //上传文件参数
      uploadParameter: {
        fileName: ""
      },
      uploadMaxLimitSize: null //最大上传文件大小
    };
  },
  methods: {
    forbidLocalUpload() {
      this.$emit("update:showCurrency", false);
      this.$alert({
        title: "提示",
        description: "批量打印最多支持10个文件"
      });
    },
    init() {
      this.getAllParametersFn();
    },
    //获取所有参数
    getAllParametersFn() {
      getAllParameters().then(res => {
        const { code, data } = res;
        if (code === 0) {
          this.uploadMaxLimitSize = data;
          //发送至发起上传弹窗用户判断文件上传格式
          sessionStorage.setItem("uploadParams", JSON.stringify(data));
        }
      });
    },
    //查询转换文档信息
    fileQueryFn(printNo) {
      fileQuery(printNo)
        .then(res => {
          const { code, data } = res;
          if (code === 0) {
            if (data.status !== 6 && data.status !== 5) {
              this.fileQueryFn(data.printNo);
            } else {
              //上传成功，展示打印选项弹窗
              this.$emit("successFile", true);
              this.percentage = 0; //进度置空
              //将printNo、targetDocId传给打印选项弹窗
              sessionStorage.setItem("printParams", JSON.stringify(data));
              //关闭当前弹窗
              this.closeFn();
            }
          }
        })
        .catch();
    },
    //文件上传失败
    err() {
      this.uploadErr = true;
      this.$refs.uploader.clearFiles();
    },
    getDocsToken() {
      return new Promise((resolve, reject) => {
        if (!window?.readerCookies?.fid) return;
        const service = axios.create({
          withCredentials: true
        });
        const url = `https://docsapi.foxitcloud.cn/user/getToken`;
        service
          .get(url, { params: { fid: window?.readerCookies?.fid } })
          .then(res => {
            const {
              data: { data }
            } = res;
            if (res.data.code !== 0) {
              reject();
              return;
            }
            localStorage.setItem(
              "docToken",
              JSON.stringify({
                token: data.token,
                expireTime:
                  new Date().getTime() + data.expireTime * 1000 - 300 * 1000
              })
            );
            resolve();
          })
          .catch(() => {
            reject();
          });
      });
    },
    //云文档
    async cloudDocument() {
      if (
        10 -
          this.uploadLists.filter(
            item => item.response && item.response.code === 0
          ).length <=
        0
      ) {
        this.$emit("update:showCurrency", false);
        return this.$alert({
          title: "提示",
          description: "批量打印最多支持10个文件"
        });
      }
      const headers = {
        appKey: APP_KEY
      };
      if (this.accessToken)
        headers.Authorization = `Bearer ${this.accessToken}`;
      const service = axios.create({
        withCredentials: true,
        headers
      });
      const url =
        process.env.NODE_ENV === "development"
          ? `/api/user/getUserInfo?v=${Math.random()}`
          : `${REQUEST_URL}/user/getUserInfo?v=${Math.random()}`;
      service.get(url).then(({ data: res }) => {
        //关闭当前
        this.closeFn();
        if (res.code === 0) {
          //打开云文档弹窗
          this.$emit("cloudDocument", true);
        } else {
          signIn();
        }
      });
    },
    //手机打印
    mobilePrintingFn() {
      this.$emit("mobile");
    },
    //取消文件上传
    cancelUploadFn() {
      this.$refs.uploader.abort();
      this.$emit("update:showCurrency", false);
    },
    //弹窗关闭
    closeFn() {
      this.$emit("update:showCurrency", false);
    }
  },
  mounted() {
    this.init();
  }
};
</script>

<style lang="scss" scoped>
.title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 64px;
  padding: 0 14px;
  span {
    font-size: 16px;
  }
}
.close i {
  display: block;
  background: url("~@/assets/img/printing/closeIcon.png") no-repeat center;
  width: 14px;
  height: 14px;
  cursor: pointer;
}
.itemBox {
  p {
    text-align: left;
  }
}
.itemList {
  margin: 20px 0 10px 0;
  li {
    box-sizing: border-box;
    width: 352px;
    height: 52px;
    background-color: #f8f8f8;
    border-radius: 4px;
    margin: 10px 0 0 0;
    font-size: 14px;
    color: #424242;
    display: flex;
    align-items: center;
    padding: 0 0 0 20px;
    cursor: pointer;
    &:first-child {
      margin: 0;
    }
    &:hover {
      background-color: #eeeeee;
      color: $theme-color;
    }
    img {
      margin: 0 14px 0 0;
    }
  }
}
.codeBox {
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #666666;
  font-size: 16px;
  .codeIcon {
    position: relative;
    img {
      width: 180px;
      height: 180px;
    }
    &:hover {
      .mask {
        display: block;
      }
      .button {
        display: block;
      }
    }
  }
  p {
    margin: 20px 0 0 0;
  }
  .mask {
    display: none;
    position: absolute;
    top: 0;
    left: 0;
    width: 180px;
    height: 180px;
    background: #000000;
    opacity: 0.7;
  }
  .button {
    display: none;
  }
  .buttonBox {
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: #ffffff;
    position: absolute;
    top: 50%;
    left: 50%;
    margin: -20px 0 0 -60px;
    width: 120px;
    height: 40px;
    border-radius: 20px;
    border: solid 1px #ffffff;
    span {
      height: 40px;
      display: flex;
      align-items: center;
      cursor: pointer;
    }
    span.saveAs {
      padding: 0 6px 0 10px;
    }
    span.copy {
      padding: 0 10px 0 6px;
    }
  }
}

.uploadProgress {
  text-align: center;
  .fileName {
    line-height: 16px;
    height: 16px;
  }
  span {
    display: inline-block;
    color: #999999;
    font-size: 12px;
    margin: 24px 0 19px 0;
    max-width: 300px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  p {
    color: #333333;
    font-size: 16px;
  }
}
.icon {
  width: 56px;
  height: 56px;
  margin: 0 auto;
  background-color: $theme-color;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.uploadProgress .dialogFooter {
  margin: 0;
  button {
    padding: 0px 20px;
    height: 32px;
  }
}

::v-deep .el-dialog__header {
  border-bottom: solid 1px #eeeeee;
  margin: 0 10px;
  padding: 0;
}
::v-deep .el-progress {
  margin: 18px 0 20px 0;
}
::v-deep .uploadProgress .el-progress-bar .el-progress-bar__outer {
  height: 4px !important;
}
</style>
